import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { GrowthBookService } from "../services/growthbook.service";

/**
 * Diretiva para mostrar/ocultar elementos baseado em feature flags do GrowthBook
 *
 * @example
 * ```html
 * <div *featureFlag="'new-dashboard-feature'">
 *   Conteúdo que só aparece se a feature flag estiver ativa
 * </div>
 *
 * <div *featureFlag="'my-feature'; else fallback">
 *   Conteúdo principal
 * </div>
 * <ng-template #fallback>
 *   Conteúdo alternativo
 * </ng-template>
 * ```
 */
@Directive({
    selector: "[featureFlag]",
})
export class FeatureFlagDirective implements OnInit {
    private hasView = false;
    private featureFlagName: string | null = null;

    @Input() set featureFlag(flagName: string | null) {
        this.featureFlagName = flagName;
        this.updateView();
    }

    @Input() featureFlagElse: TemplateRef<any> | null = null;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private growthBookService: GrowthBookService,
    ) {}

    ngOnInit(): void {
        this.updateView();
    }

    private updateView(): void {
        if (!this.featureFlagName) {
            if (this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
            return;
        }

        const isEnabled = this.growthBookService.isFeatureEnabled(this.featureFlagName);

        if (isEnabled && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!isEnabled && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;

            if (this.featureFlagElse) {
                this.viewContainer.createEmbeddedView(this.featureFlagElse);
            }
        }
    }
}

